export default {
    editEntityModal: {
        isOpen: false,
    },
    editBorrowerEntityToPrincipalLinkModal: {
        isOpen: false,
    },
    editPrincipalModal: {
        isOpen: false,
    },
    deleteBorrowerEntityToPrincipalLinkModal: {
        isOpen: false,
    },
    deleteBusinessToPrincipalLinkModal: {
        isOpen: false,
    },
    deleteForeverModal: {
        isOpen: false,
    },
    editCompanyModal: {
        isOpen: false,
    },
    recycleBinModal: {
        isOpen: false,
    },
    entityAuditHistoryModal: {
        isOpen: false,
    },
};
